export default "__VITE_PUBLIC_ASSET__75963b0b__"